// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkText_link__391_0"};